import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SeoBixScript = () => {
  const location = useLocation();

  useEffect(() => {
    const existingScript = document.getElementById("seobix-script");

    if (existingScript) {
      existingScript.remove();
    }

    const pageUrl = encodeURIComponent(window.location.href);
    const baseUrl = encodeURIComponent(window.location.origin);

    const seoScript = document.createElement("script");

    seoScript.id = "seobix-script";
    seoScript.src =
      "https://packky.com/SeoBix/seo_injection.php" +
      "?webid=cd8435ad15b4e27805d9e08fbaa8d536" +
      "&url=" +
      pageUrl +
      "&baseUrl=" +
      baseUrl;

    seoScript.async = true;
    seoScript.defer = true;

    seoScript.onload = () => {
      console.log("SeoBix loaded for:", window.location.href);
    };

    seoScript.onerror = () => {
      console.error("SeoBix failed for:", window.location.href);
    };

    document.head.appendChild(seoScript);

    return () => {
      if (document.head.contains(seoScript)) {
        document.head.removeChild(seoScript);
      }
    };
  }, [location.pathname, location.search]);

  return null;
};

export default SeoBixScript;